import QuestionBox from "../ui/QuestionBox";

type DefermentSectionProps = {
  deferment: "yes" | "no" | "";
  setDeferment: (value: "yes" | "no") => void;
};

export default function DefermentSection({
  deferment,
  setDeferment,
}: DefermentSectionProps) {
  return (
    <div className="mt-8 border-y-2 border-dashed border-gray-300 py-6">
      <div className="mb-5 flex items-center gap-2">
        <h4 className="text-lg font-semibold text-blue-800">Deferment *</h4>
        <QuestionBox title="Deferment">
          The Office will publish the registered design(s) at the end of the
          deferment period, provided that the design(s) have not been
          surrendered or published earlier. Publication is deferred for up to 30
          months from the filing date or priority date. If you want earlier
          publication, you can request publication of the registered designs at
          any time within the deferment period.
        </QuestionBox>
      </div>

      <div className="flex items-center gap-8">
        <label className="inline-flex items-center gap-3 text-lg font-semibold text-gray-800">
          <input
            type="radio"
            name="design-deferment"
            value="yes"
            checked={deferment === "yes"}
            onChange={() => setDeferment("yes")}
            className="h-5 w-5 accent-blue-800"
          />
          Yes
        </label>

        <label className="inline-flex items-center gap-3 text-lg font-semibold text-gray-800">
          <input
            type="radio"
            name="design-deferment"
            value="no"
            checked={deferment === "no"}
            onChange={() => setDeferment("no")}
            className="h-5 w-5 accent-blue-800"
          />
          No
        </label>
      </div>

      {deferment === "yes" && (
        <div className="mt-6 rounded-md border-2 border-blue-800 px-5 py-4 text-blue-800">
          <div className="flex items-start gap-4">
            <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-blue-800 text-xs font-semibold">
              i
            </span>
            <p className="text-sm font-semibold leading-relaxed">
              The Office will publish the registered design(s) at the end of the
              deferment period, provided that the design(s) have not been
              surrendered or published earlier. Publication is deferred for up
              to 30 months from the filing or priority date. If you want earlier
              publication, you can request publication of the registered
              design(s) at any time within the deferment period.
            </p>
          </div>
        </div>
      )}

      {deferment === "no" && (
        <div className="mt-6 rounded-md border-2 border-blue-800 px-5 py-4 text-blue-800">
          <div className="flex items-start gap-4">
            <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-blue-800 text-xs font-semibold">
              i
            </span>
            <p className="text-sm font-semibold leading-relaxed">
              No deferment will be requested. The design will be fully published
              after registration.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
